import { render } from "./CDISettings.vue?vue&type=template&id=c22df226&scoped=true"
import script from "./CDISettings.vue?vue&type=script&lang=js"
export * from "./CDISettings.vue?vue&type=script&lang=js"

import "./CDISettings.vue?vue&type=style&index=0&id=c22df226&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22df226"]])

export default __exports__